import {
  ExclamationTriangleIcon,
  InformationCircleIcon,
  XCircleIcon,
} from '@heroicons/react/24/outline';
import { cn } from '@/shared/lib/utils';
import type { BannerType } from '../_lib/variants';

/**
 * アイコンコンポーネント
 */
export const BannerIcon = ({ type }: { type: BannerType }) => {
  const iconClassName = 'size-4 shrink-0';
  // タイプ別アイコン
  const IconComponent = {
    neutral: InformationCircleIcon,
    error: XCircleIcon,
    warning: ExclamationTriangleIcon,
    info: InformationCircleIcon,
  }[type];

  const iconColor = {
    neutral: 'text-text-base',
    error: 'text-text-error',
    warning: 'text-text-warning',
    info: 'text-text-info',
  }[type];

  return (
    <div className="flex items-center pt-0.75">
      <IconComponent className={cn(iconClassName, iconColor)} />
    </div>
  );
};
